export const GST_FLAG_TEXT = "GST Flagged";